import React from 'react';
import ReactDOM from 'react-dom';

type PortalProps = {
  children: React.ReactNode;
};

export const Portal: React.FunctionComponent<PortalProps> = ({ children }) =>
  ReactDOM.createPortal(children, document.body);
